import React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import LinearProgress from "@mui/material/LinearProgress";
import CircularProgress from "@mui/material/CircularProgress";

import "./LoadingPage.scss";

export default function LoadingPage({ title = "Loading website…", subtitle = "Checking availability" }) {
  return (
    <Box className="lp">
      <div className="lp__blob lp__blob--a" aria-hidden="true" />
      <div className="lp__blob lp__blob--b" aria-hidden="true" />
      <div className="lp__grid" aria-hidden="true" />

      <Paper className="lp__card" elevation={0}>
        <Stack spacing={2.2} alignItems="center">
          <div className="lp__orb" aria-hidden="true">
            <div className="lp__orbRing" />
            <div className="lp__orbDot" />
            <div className="lp__orbDot lp__orbDot--2" />
          </div>

          <Stack spacing={0.6} alignItems="center">
            <Typography variant="h5" className="lp__title">
              {title}
            </Typography>
            <Typography variant="body2" className="lp__subtitle">
              {subtitle}
            </Typography>
          </Stack>

          <Box className="lp__barWrap">
            <LinearProgress />
          </Box>

          <Stack direction="row" spacing={1} alignItems="center" className="lp__hint">
            <CircularProgress size={16} />
            <Typography variant="caption" className="lp__hintText">
              Just a moment…
            </Typography>
          </Stack>
        </Stack>
      </Paper>
    </Box>
  );
}